import * as React from "react";
import InputContainer from "./InputContainer";

export type TextFieldClassNames = {
  root?: string;
  label?: string;
  container?: string;
  error?: string;
  input?: string;
};

export type TextFieldProps = {
  label?: string;
  errorMessage?: string;
  classNames?: TextFieldClassNames;
} & React.ComponentPropsWithoutRef<"input">;

const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
  (
    {
      label,
      errorMessage,
      classNames,
      required,
      className,
      id,
      "aria-describedby": ariaDescribedBy,
      "aria-invalid": ariaInvalid,
      type = "text",
      ...inputProps
    },
    ref,
  ) => {
    return (
      <InputContainer
        id={id}
        label={label}
        required={required}
        className={className}
        classNames={classNames}
        aria-invalid={ariaInvalid}
        errorMessage={errorMessage}
        aria-describedby={ariaDescribedBy}
        {...inputProps}
      >
        <InputContainer.Input
          {...inputProps}
          ref={ref}
          type={type}
          required={required}
          className={classNames?.input}
        />
      </InputContainer>
    );
  },
);

TextField.displayName = "TextField";

export default TextField;
